import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export const PIXEL_ID = '3099001053617513';
export function fireAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Adiós al Azúcar: El Reset de 14 Días',
      content_ids: ['RESET_14_DIAS'],
      content_type: 'product',
      currency: 'COP',
      value: 29999
    });
    // Also track InitiateCheckout as it's often used interchangeably for direct checkout buttons
    window.fbq('track', 'InitiateCheckout', {
      content_name: 'Adiós al Azúcar: El Reset de 14 Días',
      currency: 'COP',
      value: 29999
    });
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Initialize Pixel
    if (typeof window !== 'undefined') {
      if (!window.fbq) {
        const n: any = window.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!window._fbq) window._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const scriptEl = document.createElement('script');
        scriptEl.async = true;
        scriptEl.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(scriptEl);
        window.fbq('init', PIXEL_ID);
      }
      // Track PageView
      window.fbq('track', 'PageView');
      // Track ViewContent
      window.fbq('track', 'ViewContent', {
        content_name: 'Adiós al Azúcar: El Reset de 14 Días',
        content_ids: ['RESET_14_DIAS'],
        content_type: 'product',
        currency: 'COP',
        value: 29999
      });
    }
  }, []);
  return <noscript data-id="element-104">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-105" />
    </noscript>;
}